import React, { Component } from 'react';
import { serverIp, firebaseAuth, logComponentLoad, } from '../../../../config/constants.js'
import { Divider, Card, Grid, Button, Modal } from 'semantic-ui-react'
import * as UiConsts from '../../../../config/UiConstants'
import axios from 'axios'
import { Link } from 'react-router-dom';
import { getPrintValues, checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import ViewProject_header from './ViewProject_header';
import ViewLargeProjectOrderEntry_options_card from './ViewLargeProjectOrderEntry_options_card.js';
import UpdateItemStatus from './UpdateItemStatus.js';
import DeleteItem from './DeleteItem.js';
import CreateOrder from './CreateOrder';

class ViewLargeProjectItem_header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            order: '',
            loadingUser: true,
            loading: false,
            modalOpen: false,
            largeProject_item_models: [],
        }
    }

    componentDidMount() {
        firebaseAuth().onAuthStateChanged((user) => {

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult);

                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        });
    }

    setAdminResult = (returnObject) => {
        // console.log("++++++ addx294 setAdminResult");
        // console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        logComponentLoad(returnObject, "ViewLargeProjectItem_header");

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
            loadingUser: false
        })

        if (returnObject.isAdmin) {

            this.load_item_options(this.props.match.params.messageId);

        }
    }

    load_item_options = () => {
        // SEND CHECK TO SERVER

        this.setState({ loading: true })

        axios.post(serverIp + "large_project_items/getLargeProjectItems", {
            apiKey: "ViewLargeProjectItem_header",
            enteredBy: this.state.user.email,
            projectId: this.props.match.params.projectId
        })
            .then((response) => {

                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. ");

                    this.setState({
                        loading: false,
                        largeProject_item_models: response.data.largeProject_item_models
                    })

                    //alert(response.data.message);
                    //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("FAILED TO LOAD ITEMS");
                this.setState({
                    loading: false
                })
            });
    }


    export_googleSheets = () => {
        // SEND CHECK TO SERVER

        this.setState({ loading: true })

        axios.post(serverIp + "googleSheets/writeLargeProjectItemToSheets", {
            apiKey: "writeLargeProjectItemToSheets",
            enteredBy: this.state.user.email,
            projectId: this.props.match.params.projectId
        })
            .then((response) => {

                console.log(response.data);

                if (response.data.result) {
                    console.log("true.. ");

                    this.setState({
                        loading: false
                    })

                    alert("Items exported to Google sheet complete");
                    //history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                } else {
                    console.log("FAILED");
                    alert(response.data.message);
                }
            })
            .catch((error) => {
                console.log(error);
                alert("FAILED TO LOAD ITEMS");
                this.setState({
                    loading: false
                })
            });
    }

    render() {

        const sheetsButton = this.state.largeProject_item_models.length > 0
            ? <Button fluid color='teal' onClick={this.export_googleSheets}>EXPORT TO GOOGLE SHEET  - <a href={'https://docs.google.com/spreadsheets/d/1R9Tb1Hs5Dj7dkfhZnxEd7Y20zpiC3f6oFExGwqe_U5k/edit?usp=sharing'} target="_blank">VIEW</a>  </Button>
            : ''

        const cardRow = this.state.largeProject_item_models.length > 0
            ? this.state.largeProject_item_models.map((item, index) =>
                <Grid.Column>

                    <Card>
                        <Card.Content>
                            <Card.Header>#{item.largeProjectItemId} {item.shirtType.replace('large_project_', "")} - {item.name}</Card.Header>
                            <Card.Header>Name: {item.name}</Card.Header>
                            <Card.Header>Status: {item.status} </Card.Header>
                            <UpdateItemStatus
                                largeProjectItemId={item.largeProjectItemId}
                                user={this.state.user}
                                refresh={this.load_item_options} />

                            <DeleteItem
                                largeProjectItemId={item.largeProjectItemId}
                                user={this.state.user}
                                refresh={this.load_item_options} />


                            <CreateOrder
                                largeProjectItemId={item.largeProjectItemId}
                                user={this.state.user}
                                item={item}
                                refresh={this.load_item_options}
                            />

                            <Divider horizontal>{'OPTIONS'}</Divider>
                            <ViewLargeProjectOrderEntry_options_card
                                largeProjectItemOptions={item.itemOptions}
                                user={this.state.user}
                                largeProjectItemId={item.largeProjectItemId}
                                optionType={"option"}
                            />

                            <Divider horizontal>{'MEASUREMENTS'}</Divider>
                            <ViewLargeProjectOrderEntry_options_card
                                largeProjectItemOptions={item.itemOptions}
                                user={this.state.user}
                                largeProjectItemId={item.largeProjectItemId}
                                optionType={"measurement"}
                            />
                            {/* <ViewLargeProjectOrderEntry_options_card largeProjectItemOptions={item.measurements} /> */}
                        </Card.Content>
                    </Card>
                </Grid.Column>

            )
            : ''



        const wholeUI = this.state.algoliaUser && this.state.algoliaUser.isAdmin
            ? <div>
                <ViewProject_header projectId={this.props.match.params.projectId} user={this.state.user} />

                <Button fluid color='red'>
                    <Link to={'/dashboard/largeProjectItemSelection/' + this.props.match.params.projectId}>ENTER NEW ITEM</Link>
                </Button>

                <br />

                <Button fluid color='green'>
                    <Link to={'/dashboard/viewLargeProject/' + this.props.match.params.projectId} target="_blank">PROJECT HOME</Link>
                </Button>

                <br />
                {sheetsButton}

                <br />
                <Grid container columns={3}>
                    {cardRow}
                </Grid>


            </div>
            : <h4>loading error a75</h4>

        return (this.state.loading === true ? <UiConsts.LoadingComponent /> :
            <div>

                {wholeUI}

            </div>
        )
    }
}

export default ViewLargeProjectItem_header;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjectOrderEntry/ViewLargeProjectItem_header.js